"use client";

import { useEffect, useRef } from "react";
import { useAnalytics } from "@/hooks/useAnalytics";

type Props = {
  event: string;
  properties?: Record<string, unknown>;
};

// Generic single-fire mount tracker. Mount from any server page that wants
// to emit a single custom event when the page loads, without converting the
// page itself to a client component.
export default function PageViewTracker({ event, properties }: Props) {
  const { trackEvent } = useAnalytics();
  const fired = useRef(false);

  useEffect(() => {
    if (fired.current) return;
    fired.current = true;
    trackEvent(event, properties);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [event]);

  return null;
}
